import React, { useEffect, useState } from 'react';
import Sidebar from './components/Sidebar';
import Overview from './components/sections/Overview';
import { DocsConfigProvider } from './context/DocsConfigContext';
import CommonWorkflows from './components/sections/CommonWorkflows';
import Users from './components/sections/Users';
import Namespaces from './components/sections/Namespaces';
import Search from './components/sections/Search';
import CorpusMaps from './components/sections/CorpusMaps';
import Documents from './components/sections/Documents';
import IngestionTasks from './components/sections/IngestionTasks';
import Projects from './components/sections/Projects';
import SOPs from './components/sections/SOPs';
import SOPGeneration from './components/sections/SOPGeneration';
import SOPResources from './components/sections/SOPResources';
import SOPProposals from './components/sections/SOPProposals';
import Logs from './components/sections/Logs';

function App() {
  const [activeSection, setActiveSection] = useState('overview');
  const [activeWorkflow, setActiveWorkflow] = useState(null);

  const handleSectionChange = (sectionId) => {
    setActiveSection(sectionId);
    setActiveWorkflow(null);
  };

  const handleWorkflowChange = (workflowId) => {
    setActiveSection('common-workflows');
    setActiveWorkflow(workflowId);
  };

  // Optional: basic hash routing support for deep links
  useEffect(() => {
    const applyHash = () => {
      const hash = window.location.hash.replace('#', '');
      if (!hash) return;
      // map known hashes to sections
      const known = new Set([
        'overview', 'common-workflows', 'users', 'namespaces', 'search', 'corpus-maps', 'documents', 'ingestion-tasks', 'projects', 'sops', 'sop-generation', 'sop-resources', 'sop-proposals', 'logs'
      ]);
      if (known.has(hash)) setActiveSection(hash);
    };
    window.addEventListener('popstate', applyHash);
    applyHash();
    return () => window.removeEventListener('popstate', applyHash);
  }, []);

  return (
    <DocsConfigProvider>
      <div className="flex h-screen overflow-hidden">
        <Sidebar
          activeSection={activeSection}
          activeWorkflow={activeWorkflow}
          onSectionChange={handleSectionChange}
          onWorkflowChange={handleWorkflowChange}
        />
        <main className="flex-1 overflow-y-auto scrollbar-thin p-8 bg-gray-900">
          {activeSection === 'overview' && (
            <Overview onNavigateToWorkflow={handleWorkflowChange} />
          )}
          {activeSection === 'common-workflows' && (
            <CommonWorkflows activeWorkflow={activeWorkflow} />
          )}
          {activeSection === 'users' && <Users />}
          {activeSection === 'namespaces' && <Namespaces />}
          {activeSection === 'search' && <Search />}
          {activeSection === 'corpus-maps' && <CorpusMaps />}
          {activeSection === 'documents' && <Documents />}
          {activeSection === 'ingestion-tasks' && <IngestionTasks />}
          {activeSection === 'projects' && <Projects />}
          {activeSection === 'sops' && <SOPs />}
          {activeSection === 'sop-generation' && <SOPGeneration />}
          {activeSection === 'sop-resources' && <SOPResources />}
          {activeSection === 'sop-proposals' && <SOPProposals />}
          {activeSection === 'logs' && <Logs />}
        </main>
      </div>
    </DocsConfigProvider>
  );
}

export default App;
